import { ERROR_CODES } from '@shared/constants/errorCodes';

export const generateBtnTextByErrorCode = (errorCode = '') => {
  switch (errorCode) {
    case ERROR_CODES.ADDED_SAME_NRIC: // ICON0029
    case ERROR_CODES.FAMILY_AND_FRIEND_PENDING_REQUEST: // ICON0030
    case ERROR_CODES.NRIC_IS_ABOUT_21_YEAR: // F0004
      return 'Close';
    case ERROR_CODES.BIRTH_DATE_AND_BIRTH_YEAR_NULL: // ICON0008
    case ERROR_CODES.BIRTH_DATE_IS_NULL: // ICON0012
    case ERROR_CODES.DATE_OF_DEATH: // U0010
    case ERROR_CODES.NRIC_NULL_BIRTHDAY: // U0009
      return 'Back';
    case ERROR_CODES.BIRTH_DATE_LESS_THAN_21_YEAR: // ICON0007
    case ERROR_CODES.NRIC_STARTS_MFG: // U0008
      return 'Ok';
    case ERROR_CODES.NEHR_CES_WEB: // ICON0003
      return 'Refresh';
    case ERROR_CODES.ADDED_SAME_NRIC_LOGIN_CHILDREN: // ICON0035
    case ERROR_CODES.ADDED_SAME_NRIC_LOGIN_FAMILY_AND_FRIEND: // ICON0025
    case ERROR_CODES.ADDED_SAME_NRIC_WITH_REQUESTER: // ICON0005
    case ERROR_CODES.CHILD_NOT_RELATED_TO_PARENT: // ICON0034
    case ERROR_CODES.CHILDREN_ALREADY_ADDED: // ICON0033
    case ERROR_CODES.FAMILY_AND_FRIEND_ALREADY_ADD: // ICON0024
    case ERROR_CODES.FAMILY_AND_FRIEND_NULL_POPULATION_MASTER: // ICON0031
    case ERROR_CODES.ICON0009: // ICON0009
    case ERROR_CODES.ICON0032: // ICON0032
    case ERROR_CODES.ICON0036: // ICON0036
    case ERROR_CODES.NRIC_NOT_FOUND_POPULATION_MASTER: // ICON0010
    case ERROR_CODES.OWNER_NULL_POPULATION_MASTER: // ICON0006
    default:
      return 'OK';
  }
};
